export default "__VITE_ASSET__CqnFemuP__"